import { Pipe, PipeTransform } from '@angular/core';

/**
 * Cuts the string at the | in order to more easily break translations.
 */
@Pipe({ name: 'translateCut' })
export class TranslateCut implements PipeTransform {
  transform(value: string, index: string | number): string {
    const cutIndex = Number(index);
    return value.split('|')[cutIndex];
  }
}
